module.exports = __webpack_public_path__ + "omlazeni-pleti_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/laserova-estetika/omlazeni-pleti_1_before.jpg
// module id = 1014
// module chunks = 0